<template>
  <div>
    <table class="table table-hover table-sm mt-1">
      <thead>
      <tr>
        <th width="150px">Заявка</th>
        <th>Клиент</th>
        <th>Адрес</th>
        <th>Препараты</th>
        <th>Сумма для карты</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(o, i) in orders" :key="o.id" :class="{selected: compareSum === o.no_cash_price}">
        <td>
          <p class="border">
            <button
              @click="openOrderInModal(o.id)"
              class="btn btn-xs btn-info mr-1">
              <i class="icon-fa icon-fa-eye"></i>
            </button>
            {{ o.id }}
          </p>
          <p>{{ o.project_label }}
            <span v-html="printOrderStatus(o)"/>
          </p>
          <p class="text-muted">{{ printDate(o.created_at) }}</p>
        </td>
        <td>
          <p>{{ o.client_name }}</p>
          <div v-for="p in o.order_phones" class="flex align-items-center border">
            <MakeCall :phone="p.phone" :order="o">
              <slot>
                <button class="btn btn-xs btn-success mr-1">
                  <i class="icon-fa icon-fa-phone-square"/>
                </button>
              </slot>
            </MakeCall>
            {{ p.phone.phone }}
          </div>
        </td>
        <td>
          <p>{{ o.address }}</p>
        </td>
        <td>
          <p v-for="d in o.details">{{ d.new_drug.title }} x {{ d.qty }} x <strong>{{ d.price }}</strong></p>
        </td>
        <td>
          <div class="flex">
            <PrePaidButton :order="o"/>
            <p class="text-center"><strong>{{ o.no_cash_price }}</strong></p>
          </div>
        </td>
        <td>
          <LoadingButton
            title="подтвердить"
            className="btn btn-success btn-xs"
            :onClick="() => makePair(o)"
            :loading="loadingBtn[o.id]"
            :color="$constants.LOADING_COLOR"
          />
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton";
import api from "@/api";
import MakeCall from "@/components/orders/telephony/MakeCall";
import PrePaidButton from "@/components/orders/prePaid/PrePaidButton.vue";

export default {
  props: ['orders', 'comment', 'selectedCard', 'compareSum'],
  components: {
    PrePaidButton,
    LoadingButton,
    MakeCall,
  },
  data() {
    return {
      loadingBtn: {},
    }
  },
  methods: {
    openOrderInModal(orderId) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: orderId})
    },
    async makePair(order) {
      if (this.progress) return;
      if (!this.comment) {
        toastr['warning']('Укажите комментарий к оплате');
        return;
      }
      this.progress = true;
      this.loadingBtn[order.id] = true;
      this.loadingBtn = {...this.loadingBtn};
      const {data} = await api.post('/new/orders/updateByAction', {
        action: 'acceptPrePaid',
        order_id: order.id,
        prePaid: {
          smsRecord_id: this.selectedCard.id,
          comment: this.comment,
          sum: order.no_cash_price,
        }
      })
      if (data.success) {
        this.selectedCard = null;
        // this.orders = [];
        // this.gerRecords();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loadingBtn[order.id] = false;
      this.progress = false;
    },
  }
}

</script>

<style scoped>
tr.selected {
  background-color: #00800014;
}
</style>
